import styled from 'styled-components';

export const Tab = styled.button`
  padding: 8px 15px;
  background-color: unset;
  color: ${({ $color, selected }) => selected ? 'black' : $color};
  border: unset;
  border-bottom: 3px solid ${({ selected }) => selected ? 'black' : 'transparent'};
  cursor: pointer;
  outline-color: ${({ $bgColor }) => $bgColor};
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
